import FieldNumeric from './FieldNumeric'

export default FieldNumeric
